import {LocalStorage, Guest, getFeatureFlags} from '@chekin/core';
import {FEEDBACK_MODAL_SHOWN_KEY} from './constants';
import ChekinProSettings from '../../ChekinProSettings';

export const shouldShowFeedbackModalToUser = (data: Guest) => {
  const isFeatureEnabled = getFeatureFlags('FEEDBACK_MODAL_ENABLED');
  const isShown = LocalStorage.get(FEEDBACK_MODAL_SHOWN_KEY);
  return !isShown && data.is_leader && !ChekinProSettings.isSDK && isFeatureEnabled;
};

export const setFeedbackModalShown = () => {
  LocalStorage.set(FEEDBACK_MODAL_SHOWN_KEY, true);
};
